import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import Header from 'components/Header';
import { Form, Input, Icon } from 'semantic-ui-react';
import CancelGoButtons from 'components/CancelGoButtons';
import API from 'utils/api';

class BillNameForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      saving: false,
      fetchError: null,
      saveError: null,
      billId: null,
      name: '',
    };
  }

  componentDidMount() {
    const billId = parseInt(this.props.match.params.billId, 10);
    this.setState({ billId, fetchError: null });

    API.getBill(billId)
      .then((response) => {
        const bill = response.data;
        this.setState({
          name: bill.name != null ? String(bill.name) : '',
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          fetchError: 'No se encontró la cuenta',
        });
      });
  }

  handleName = (event) => {
    this.setState({ name: event.target.value });
  };

  backToBill = () => {
    const { billId } = this.state;
    this.props.history.push(`/bills/${billId}`);
  };

  saveBillName = () => {
    const { billId, name } = this.state;
    this.setState({ saving: true, saveError: null });

    const params = { name: name.trim() };

    API.updateBillName(billId, params)
      .then(() => {
        setTimeout(() => {
          this.props.history.push(`/bills/${billId}`);
        }, 300);
      })
      .catch(() => {
        this.setState({
          saving: false,
          saveError: 'Error al guardar el nombre',
        });
      });
  };

  render() {
    const { loading, saving, fetchError, saveError, billId, name } = this.state;
    const billPath = billId != null ? `/bills/${billId}` : '/bills';

    return (
      <div>
        <div style={{ marginBottom: '0.5em' }}>
          <Link
            to={billPath}
            style={{
              color: '#777',
              fontSize: '0.95em',
              cursor: 'pointer',
            }}
          >
            ← regresar a la cuenta
          </Link>
        </div>

        <Header text={`Editar nombre de la cuenta #${this.props.match.params.billId}`} />

        {loading ? (
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <Icon loading name="spinner" size="large" />
            <p style={{ marginTop: '1em', color: '#666' }}>Cargando...</p>
          </div>
        ) : fetchError ? (
          <div
            style={{
              color: '#db2828',
              marginTop: '1.5em',
              padding: '12px',
              backgroundColor: '#fff6f6',
              borderRadius: '4px',
              fontSize: '1.1em',
            }}
          >
            {fetchError}
          </div>
        ) : (
          <Form as="div" style={{ marginTop: '1.5em' }}>
            {saveError && (
              <div
                style={{
                  color: '#db2828',
                  marginBottom: '1.5em',
                  padding: '12px',
                  backgroundColor: '#fff6f6',
                  borderRadius: '4px',
                  fontSize: '1.1em',
                }}
              >
                {saveError}
              </div>
            )}

            <Form.Field style={{ marginBottom: '1.5em' }}>
              <label
                style={{
                  fontSize: '1.1em',
                  color: '#666',
                  marginBottom: '8px',
                  display: 'block',
                }}
              >
                Nombre o etiqueta:
              </label>
              <Input
                value={name}
                onChange={this.handleName}
                placeholder="Ejemplo: Mesa 5"
                disabled={saving}
                maxLength={255}
                style={{ fontSize: '1.2em', height: '54px' }}
              />
              <p style={{ marginTop: '10px', color: '#888', fontSize: '0.95em' }}>
                Opcional. Si lo dejas en blanco, la cuenta se mostrará solo con su número (Cuenta #
                {billId}
                ).
              </p>
            </Form.Field>

            <CancelGoButtons
              cancelFn={this.backToBill}
              goText="guardar nombre"
              goFn={this.saveBillName}
              goEnabled={!saving}
              loading={saving}
              style={{
                button: {
                  height: '54px',
                  fontSize: '1.1em',
                  fontWeight: 'bold',
                  boxShadow: 'none',
                  borderRadius: '8px',
                },
              }}
            />
          </Form>
        )}
      </div>
    );
  }
}

export default withRouter(BillNameForm);
